import React, { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { withRouteAccessCheck } from '../../../../../app/Hoc/WithLoginAceessCheck.js';
import CustomSnackbar from '../../../../components/customComponents/CustomSnackbar/index';
import { validateForm } from '../../../../../features/components/customComponents/customValidation/index';
import { validate } from './validations.jsx';
import ManageUsers from './manageUser.jsx'
import AddCustomerByAdmin from './AddCustomerByAdmin.jsx';

const ManageMyAccountLogins = () => {
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [successMessage, setSuccesMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [step, setStep] = useState('1');
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
    phone: ''
  });
  const updatFormData = (feild, val) => {
    const curFormData = { ...formData };
    curFormData[feild] = val;
    setFormData({ ...curFormData });
  };
  const validateEmail = () => {
    const validationRules = {
      email: {
        required: true,
        name: 'Email',
        format: /^[^@]+@[^@]+\.[^@]+$/
      }
    };
    return validateForm(formData, validationRules); // returns error object
  };

  const onValidate = async () => {
    let curFormData = { ...formData };
    const baseErrors = validate(curFormData); // from password and others
    const emailErrors = validateEmail(); // from email only
    const combinedErrors = { ...baseErrors, ...emailErrors };
    setErrors(combinedErrors);
    const noError = Object.keys(combinedErrors).length === 0;
    if (noError) {
    }

    return noError;
  };

  return (
    <>
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={
          successMessage?.includes('Failed') || successMessage?.includes('Please')
            ? 'error'
            : 'success'
        }
        message={successMessage}
        autoHideDuration={1500}
        handleClose={() => {
          setOpenSnackbar(false);
        }}
      />
      <div className="row min-h-100 margin-minus-20">
        <div className="col-xxl-12">
          <div className="card card-custom card-xxl-stretch payment-card">
            <div className="card-header with_hr_tabs">
              <ul className="nav nav-tabs d-flex flex-fill" id="myTab" role="tablist">
                <li className="nav-item flex-fill text-center" role="presentation">
                  <button
                    className="nav-link w-100 active"
                    id="Allmessage-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Allmessage"
                    type="button"
                    role="tab"
                    aria-controls="Allmessage-tab-pane"
                    aria-selected="true"
                  >
                    Add User
                  </button>
                </li>
                <li className="nav-item flex-fill text-center" role="presentation">
                  <button
                    className="nav-link w-100"
                    id="manageuser-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#manageUser"
                    type="button"
                    role="tab"
                    aria-controls="manageuser-tab-pane"
                    aria-selected="false"
                  >
                    Manage User
                  </button>
                </li>
              </ul>
              <div className="head_btn align-items-center d-flex"></div>
            </div>
            <div className="card-body">
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="Allmessage"
                  role="tabpanel"
                  aria-labelledby="Allmessage-tab"
                  tabIndex="0"
                >
                  <AddCustomerByAdmin />
                </div>
                <div
                  className="tab-pane fade"
                  id="manageUser"
                  role="tabpanel"
                  aria-labelledby="manageuser-tab"
                  tabIndex="0"
                >
                  <ManageUsers />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default withRouteAccessCheck(ManageMyAccountLogins);
